import { Injectable } from '@angular/core';
import { ProfileBusinessInfo, ProfileUserInfo } from '@models/profile';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileContextService {
  changePhoneBlockedByTimeStamp = new BehaviorSubject('');
  signingKeyBlockedTimeStamp = new BehaviorSubject<string>('');

  private changedPhone$: Subject<void> = new Subject();
  private changedSigningKey$: Subject<void> = new Subject();
  private state: BehaviorSubject<ProfileUserInfo | ProfileBusinessInfo> = new BehaviorSubject(null as any);

  constructor() {}

  getChangedPhoneObservable() {
    return this.changedPhone$.asObservable();
  }

  emitChangedPhone() {
    this.changedPhone$.next();
  }

  getSigningKeyChangeObservable() {
    return this.changedSigningKey$.asObservable();
  }

  emitChangedSigningKey() {
    this.changedSigningKey$.next();
  }

  getState$() {
    return this.state.asObservable();
  }

  getState() {
    return this.state.getValue();
  }

  updateState(state: ProfileUserInfo | ProfileBusinessInfo) {
    const newState = { ...this.getState(), ...state };
    this.state.next(newState);
  }

  clear() {
    this.changePhoneBlockedByTimeStamp.next('');
    this.signingKeyBlockedTimeStamp.next('');
    this.state.next(null as ProfileUserInfo | ProfileBusinessInfo);
  }
}
